import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class School extends DynamicFieldsSerializer {
  _payloadKeySingular = 'school';
  _payloadKeyPlural = 'schools';
  _fieldsKey = 'options';

  normalize(typeClass, hash) {
    // Merge empty strings into the payload, as Go's `omitempty` will omit them
    // (leading to ember-data assuming that they're unchanged).
    let defaults = {
      phone: '',
      emailAddress: '',
    };
    Object.assign(defaults, hash);
    hash = defaults;

    return super.normalize(typeClass, hash);
  }
}
